import '../../../../styles/globals.css'
import { Box, Typography } from '@mui/material'
import karmaStyles from '../../../../styles/KarmaPool.module.css'
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useKarmaPoolContext } from '../../../../state/KarmaPoolContext';

import ProfilePictureDefault from '../../../../images/profile_pictures/default.png';

function ProfileIcon(props) {

    const karmaContext = useKarmaPoolContext();

    const [profileImageURL, setProfileImageURL] = useState(null);

    useEffect(() => {
        setProfileImageURL(getImageId());
    }, [props.note]);

    function getImageId() {
        console.log("notes here: " + props.note);
        if (props.note !== null && props.note !== undefined) {
            return props.note.profileImageUrl;
        }
        return null;
    }

    return (
        <Box sx={{ marginRight: "0.825rem", marginLeft: "0.25rem" }} >
            <img
                src={profileImageURL !== null ?
                    "https://imagedelivery.net/VOV6-bP9OpL34z4U0gUIFw/" + profileImageURL + "/profilepicture256" : ProfilePictureDefault}
                style={{ width: "1.925rem", height: "1.925rem", borderRadius: "50%", border: "2px solid rgba(216,216,216, 0.825)" }}
                alt="profile-pic" width={"96"} height={"96"} />
            {/*<img src={ProfilePictureDefault} alt="profile icon" style={{ width: "1.925rem", height: "1.925rem", borderRadius: "50%", border: "2px solid rgba(216,216,216, 0.825)" }} /> */}
        </Box>
    );

}

function UsernameIconDisplay(props) {
    return (
        <Typography variant="body2" component="div" gutterBottom>
            <Box sx={{ display: "flex", alignItems: "center", marginTop: "0.225rem" }}>
                <Link to={`/karma/dashboard/profile?userId=${props.note.userId}`} >
                    <Box sx={{ display: "flex", alignItems: "center", marginTop: "0.225rem" }}>
                        <ProfileIcon note={props.note} />
                    </Box>
                </Link>
                <Link to={`/karma/dashboard/profile?userId=${props.note.userId}`} className={karmaStyles.link}>
                    <Box sx={{ display: "flex", alignItems: "center", marginTop: "0.225rem" }}>
                        <Box sx={{ width: "6.25rem", display: "flex", float: "left" }} >
                            <Typography variant="body2" component="div" gutterBottom sx={{ fontSize: "0.825rem", fontWeight: "600", marginTop: "0.0rem" }}>
                                {props.note.displayName}
                            </Typography>
                        </Box>
                        <Box sx={{ width: "2.25rem", display: "flex", float: "left" }} >
                            <Typography variant="body2" component="div" gutterBottom sx={{ fontSize: "0.825rem", marginLeft: "0.825rem", color: "rgba(256, 256, 256, 0.6)" }}>
                                {/*follow */}
                            </Typography>
                        </Box>
                    </Box>
                </Link>
            </Box>
        </Typography>
    );
}

export default UsernameIconDisplay;
